import { CloseSquare, Discount, User, Discovery, Paper, InfoSquare, Password, PaperPlus, Unlock, Bookmark, Message } from "react-iconly";
import IntlMessages from "../../layout/components/lang/IntlMessages";

const pages = [
    {
        id: "pages",
        header: <IntlMessages id="sidebar-pages" />,
        subMenu: [
            {
                id: "errors",
                title: <IntlMessages id="sidebar-pages-error" />,
                icon: <CloseSquare set="curved" className="remix-icon" />,
                children: [
                    {
                        id: "error-404",
                        title: "404",
                        navLink: "/pages/error-404",
                    },
                    {
                        id: "error-403",
                        title: "403",
                        navLink: "/pages/error-403",
                    },
                    {
                        id: "error-500",
                        title: "500",
                        navLink: "/pages/error-500",
                    },
                    {
                        id: "error-503",
                        title: "503",
                        navLink: "/pages/error-503",
                    },
                    {
                        id: "error-502",
                        title: "502",
                        navLink: "/pages/error-502",
                    },
                    {
                        id: "maintenance",
                        title: <IntlMessages id="sidebar-pages-error-maintenance" />,
                        navLink: "/pages/maintenance",
                    },
                    {
                        id: "comming-soon",
                        title: <IntlMessages id="sidebar-pages-error-coming-soon" />,
                        navLink: "/pages/coming-soon",
                    },
                ],
            },
            {
                id: "landing",
                title: <IntlMessages id="sidebar-pages-landing" />,
                icon: <Discovery set="curved" className="remix-icon" />,
                navLink: "/pages/landing",
            },
            {
                id: "pricing",
                title: <IntlMessages id="sidebar-pages-pricing" />,
                icon: <Discount set="curved" className="remix-icon" />,
                navLink: "/pages/pricing",
            },
            {
                id: "profile",
                title: <IntlMessages id="sidebar-pages-profile" />,
                icon: <User set="curved" className="remix-icon" />,
                children: [
                    {
                        id: "profile-personel-information",
                        title: <IntlMessages id="sidebar-pages-profile-personel-information" />,
                        navLink: "/pages/profile/personel-information",
                    },
                    {
                        id: "profile-notifications",
                        title: <IntlMessages id="sidebar-pages-profile-notifications" />,
                        navLink: "/pages/profile/notifications",
                    },
                    {
                        id: "profile-activity",
                        title: <IntlMessages id="sidebar-pages-profile-activity-monitor" />,
                        navLink: "/pages/profile/activity",
                    },
                    {
                        id: "profile-security",
                        title: <IntlMessages id="sidebar-pages-profile-security-settings" />,
                        navLink: "/pages/profile/security",
                    },
                    {
                        id: "profile-password-change",
                        title: <IntlMessages id="sidebar-pages-profile-password-change" />,
                        navLink: "/pages/profile/password-change",
                    },
                    {
                        id: "profile-connect-with-social",
                        title: <IntlMessages id="sidebar-pages-profile-connect-with-social" />,
                        navLink: "/pages/profile/connect-with-social",
                    },
                ],
            },
            {
                id: "invoice",
                title: <IntlMessages id="sidebar-pages-invoice" />,
                icon: <Paper set="curved" className="remix-icon" />,
                navLink: "/invoice",
            },
            {
                id: "email",
                title: <IntlMessages id="sidebar-pages-email-templates" />,
                icon: <Message set="curved" className="remix-icon" />,
                children: [
                    {
                        id: "email-hello",
                        title: <IntlMessages id="sidebar-pages-email-hello" />,
                        navLink: "https://yoda.hypeople.studio/yoda-email-template/hello.html",
                    },
                    {
                        id: "email-promotional",
                        title: <IntlMessages id="sidebar-pages-email-promotional" />,
                        navLink: "https://yoda.hypeople.studio/yoda-email-template/promotional.html",
                    },
                    {
                        id: "email-verify",
                        title: <IntlMessages id="sidebar-pages-email-verify" />,
                        navLink: "https://yoda.hypeople.studio/yoda-email-template/verify.html",
                    },
                    {
                        id: "email-reset-password",
                        title: <IntlMessages id="sidebar-pages-email-reset-password" />,
                        navLink: "https://yoda.hypeople.studio/yoda-email-template/reset-password.html",
                    },
                    {
                        id: "email-term",
                        title: <IntlMessages id="sidebar-pages-email-term" />,
                        navLink: "https://yoda.hypeople.studio/yoda-email-template/term.html",
                    },
                    {
                        id: "email-deactive-account",
                        title: <IntlMessages id="sidebar-pages-email-deactive-account" />,
                        navLink: "https://yoda.hypeople.studio/yoda-email-template/deactive-account.html",
                    },
                ],
            },
            {
                id: "faq",
                title: <IntlMessages id="sidebar-pages-faq" />,
                icon: <InfoSquare set="curved" className="remix-icon" />,
                navLink: "/pages/faq",
            },
            {
                id: "knowledge-base",
                title: <IntlMessages id="sidebar-pages-knowledge-base" />,
                icon: <Bookmark set="curved" className="remix-icon" />,
                children: [
                    {
                        id: "knowledge-base-1",
                        title: <IntlMessages id="sidebar-pages-knowledge-base-1" />,
                        navLink: "/pages/knowledge-base/knowledge-base-1",
                    },
                    {
                        id: "knowledge-base-2",
                        title: <IntlMessages id="sidebar-pages-knowledge-base-2" />,
                        navLink: "/pages/knowledge-base/knowledge-base-2",
                    },
                ],
            },
            {
                id: "blank-page",
                title: <IntlMessages id="sidebar-pages-blank-page" />,
                icon: <PaperPlus set="curved" className="remix-icon" />,
                navLink: "/pages/blank-page",
            },
            {
                id: "authentication",
                title: <IntlMessages id="sidebar-pages-authentication" />,
                icon: <Unlock set="curved" className="remix-icon" />,
                children: [
                    {
                        id: "login-page",
                        title: <IntlMessages id="sidebar-pages-login" />,
                        navLink: "/pages/authentication/login",
                    },
                    {
                        id: "register-page",
                        title: <IntlMessages id="sidebar-pages-register" />,
                        navLink: "/pages/authentication/register",
                    },
                    {
                        id: "recover-password",
                        title: <IntlMessages id="sidebar-pages-recover-password" />,
                        navLink: "/pages/authentication/recover-password",
                    },
                    {
                        id: "reset-password",
                        title: <IntlMessages id="sidebar-pages-reset-password" />,
                        navLink: "/pages/authentication/reset-password",
                    },
                ],
            },
            {
                id: "lock-page",
                title: <IntlMessages id="sidebar-pages-lock-screen" />,
                icon: <Password set="curved" className="remix-icon" />,
                children: [
                    {
                        id: "welcome",
                        title: <IntlMessages id="sidebar-pages-welcome" />,
                        navLink: "/pages/welcome",
                    },
                    {
                        id: "password-is-changed",
                        title: <IntlMessages id="sidebar-pages-password-is-changed" />,
                        navLink: "/pages/password-is-changed",
                    },
                    {
                        id: "deactivated",
                        title: <IntlMessages id="sidebar-pages-deactivated" />,
                        navLink: "/pages/deactivated",
                    },
                    {
                        id: "lock",
                        title: <IntlMessages id="sidebar-pages-lock" />,
                        navLink: "/pages/lock",
                    },
                ],
            },
        ]
    },
];

export default pages